<template>
  <div class="carousel-slide">
    <div class="carousel-slide__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.carousel-slide {
  display: block;
}
</style>
